import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const Flag = ({ label, on, id }) => (
  <div className="flex justify-between gap-3 py-1.5 text-sm border-b border-stone-100">
    <span className="text-stone-500 min-w-0 break-words">{label}</span>
    <span className={`font-bold ${on ? "text-red-600" : "text-emerald-700"}`} data-testid={id}>{on ? "ON" : "OFF"}</span>
  </div>
);

export const VoiceStatusCard = ({ st, reload }) => {
  const [reason, setReason] = useState("");
  const toggle = async (dir, on) => {
    const confirm = on ? window.prompt(`Type ENABLE to turn the ${dir} admin toggle on. Real telephony still stays off: no provider is implemented and the server env switch is false.`) : null;
    if (on && confirm !== "ENABLE") return;
    try { await api.put("/admin/voice/telephony", { [dir]: on, reason, confirm }); toast.success("Saved · audit logged"); setReason(""); reload(); }
    catch (e) { toast.error(e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || "Save failed"); }
  };
  return (
    <div className="min-w-0 rounded-2xl border border-stone-200 bg-white p-4 space-y-3" data-testid="voice-status-card">
      <div className="flex items-center gap-2">
        <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 text-xs font-black" data-testid="voice-mode-badge">MOCK MODE</span>
        <span className="text-xs text-stone-500">No real calls, speech recognition, SMS or recordings. Typed input stands in for speech and is labelled MOCK.</span>
      </div>
      {["inbound", "outbound"].map((dir) => (
        <div key={dir} className="rounded-xl bg-stone-50 p-3">
          <div className="text-xs font-black uppercase tracking-widest text-stone-500 mb-1">{dir} telephony</div>
          <Flag label={`Server env switch (TELEPHONY_${dir.toUpperCase()}_ENABLED)`} on={st[dir].env} id={`voice-${dir}-env`} />
          <Flag label="Admin toggle (database)" on={st[dir].admin} id={`voice-${dir}-admin`} />
          <Flag label="Effective (real calls)" on={st[dir].effective} id={`voice-${dir}-effective`} />
          <div className="flex gap-2 mt-2">
            <button disabled={reason.trim().length < 5 || st[dir].admin} onClick={() => toggle(dir, true)} data-testid={`voice-${dir}-enable`}
                    className="h-9 px-3 rounded-full bg-stone-900 text-white text-xs font-bold disabled:opacity-40">Admin toggle ON</button>
            <button disabled={reason.trim().length < 5 || !st[dir].admin} onClick={() => toggle(dir, false)} data-testid={`voice-${dir}-disable`}
                    className="h-9 px-3 rounded-full border border-stone-300 text-xs font-bold disabled:opacity-40">OFF</button>
          </div>
        </div>
      ))}
      <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason for a toggle change (required, audit logged)"
             className="w-full h-10 rounded-xl border border-stone-200 px-3 text-sm" data-testid="voice-toggle-reason" />
      <div className="text-xs text-stone-600 break-all" data-testid="voice-paid-flags">
        Paid / external flags: {Object.entries(st.paid_flags).map(([k, v]) => `${k}=${v ? "ON" : "off"}`).join(" · ")}
      </div>
      <div className="text-xs text-stone-500 break-all" data-testid="voice-stats-mock">
        MOCK activity only: sessions {JSON.stringify(st.stats_mock.sessions)} · callbacks {JSON.stringify(st.stats_mock.callbacks)} ·
        voice registrations {st.stats_mock.voice_registrations} · job interests {st.stats_mock.job_interests}. Production stats: none (no real telephony).
      </div>
    </div>
  );
};
